import NewsletterModel          from './NewsletterModel';
import NotificationServiceModel from '@/models/NotificationServiceModel';
import SubscriptionStatusModel  from './SubscriptionStatusModel';
import doc                      from '@widesk-core/decorators/doc';

@doc.path('/stonecode_notification_subscriptions/{?id}')
export default class SubscriptionModel extends NotificationServiceModel {

	get enabled(): boolean {
		return this.get('enabled', false);
	}

	@doc.model(NewsletterModel) declare channel: NewsletterModel;
	@doc.model(SubscriptionStatusModel) declare subscriptionStatus: SubscriptionStatusModel;
}